import { render, staticRenderFns } from "./navItem.vue?vue&type=template&id=29d410a4&scoped=true&"
import script from "./navItem.vue?vue&type=script&lang=js&"
export * from "./navItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d410a4",
  null
  
)

export default component.exports